module.exports = "https://cwa.roocdn.com/_next/static/business.33b3f32a.jpg";